import styled from 'styled-components';
const UploadListItemStyle = styled.div `
	.list-item-container {
		display: inline-block;
		width: 100px;
		height: 100px;

		.image-cont {
			padding-top: 100%;
		}
	}
`;
export default UploadListItemStyle;
//# sourceMappingURL=style.js.map